import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { Classroom } from '../dropdown-classroom/org.classroom';
import { PostBaselineProgress } from '../graphs/post-baseline-progress';
import { OptionsMenu } from '../options-menu/options-menu.component';
import { OrgService } from '../_services/org.service';
import { ReportService } from '../_services/report-service';
import { PhaseService } from '../_services/phase.service';
import { LoaderService } from '../loader/loader.service';
@Component({
	selector: 'progress-bar-classroom',
	templateUrl: './progress-bar-classroom.component.html',
})
export class ProgressBarClassroomComponent implements OnInit {
	subscriptions: Subscription[] = [];
	selectedClassroom: Classroom;
	selectedPhase: any;
	graphData: PostBaselineProgress;
	classIndex = 0;
	constructor(
		private orgService: OrgService,
		private reportService: ReportService,
		private phaseService: PhaseService,
		public LoaderService: LoaderService,
	) {}

	ngOnInit(): void {
		this.subscriptions.push(
			this.orgService.selectedClassroom$.subscribe((data: any) => {
				this.selectedClassroom = data;
			}),
		);

		this.subscriptions.push(
			this.phaseService.selectedPhase$.subscribe((phase: any) => {
				if (this.selectedClassroom) {
					this.selectedPhase = phase;
					this.getGraphDataClass(phase);
				}
			}),
		);

		this.subscriptions.push(
			this.orgService.selectedClassroom$.subscribe((data: Classroom) => {
				//any classroom data change will get graph data.
				this.selectedClassroom = data;

				if (this.selectedClassroom && this.selectedPhase) {
					this.getGraphDataClass(this.selectedPhase);
				}
			}),
		);

		this.subscriptions.push(
			this.reportService.postBaselineProgressClassroom.subscribe(
				(graphData: PostBaselineProgress) => {
					//any graph data change will cause a redraw.
					this.graphData = graphData;
				},
			),
		);
	}
	changeClassroom(index, eachUnitGraph) {
		console.log(eachUnitGraph);
		this.classIndex = index;
	}

	private getGraphDataClass(phase) {
		this.subscriptions.push(
			this.reportService
				.getProgAfterBaselineForClassroom(
					this.selectedClassroom.id,
					phase.assessmentBookId,
					phase.assessmentTemplateId,
				)
				.subscribe(
					(data) => {
						//init graph data from db.
						this.reportService.setgrogressAfterBaselineClassroom(data);
					},
					(error) => {
						console.log(error);
					},
				),
		);
	}

	ngOnDestroy() {
		this.subscriptions.forEach((sub) => sub.unsubscribe());
	}
}
